import { useEffect, useState } from 'react';

function useDebounce<T>(value: T, delay = 300, ignoreDebounce?: ((_value: T) => boolean) | boolean): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    if (typeof ignoreDebounce === 'function' ? ignoreDebounce(value) : !!ignoreDebounce) {
      setDebouncedValue(value);
      return;
    }

    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [delay, ignoreDebounce, value]);

  return debouncedValue;
}

export default useDebounce;
